<template>
    <carousel ref="carousel" :autoplay="false" :nav="false" :items="2" :margin="15" :dots="false" :stagePadding="15">
        <router-link class="d-block" :to="'about-generali'">
            <div class="caption round-medium shadow-huge bottom-10 card bg-text-1 bg-wrapper" :style="index==0 ? '':'opacity: 0.5'">
                <div class="position-bottom custom-mrg-btm-18 custom-horizontal-12">
                    <div class="left-text color-white bg-text-font">About</div>
                    <div class="left-text color-white bg-text-font">Generali</div>
                </div>  
            </div>
        </router-link>
        <router-link class="d-block" :to="'our-history'">
            <div class="caption round-medium shadow-huge bottom-10 card bg-text-2 bg-wrapper" :style="index==1 ? '':'opacity: 0.5'">
                <div class="position-bottom custom-mrg-btm-18 custom-horizontal-12">
                    <div class="left-text color-white bg-text-font">Our</div>
                    <div class="left-text color-white bg-text-font">History</div>
                </div>  
            </div>
        </router-link>
        <router-link class="d-block" :to="'our-culture'">
            <div class="caption round-medium shadow-huge bottom-10 card bg-text-3 bg-wrapper" :style="index==2 ? '':'opacity: 0.5'">
                <div class="position-bottom custom-mrg-btm-18 custom-horizontal-12">
                    <div class="left-text color-white bg-text-font">Our</div>
                    <div class="left-text color-white bg-text-font">Culture</div>
                </div>  
            </div>
        </router-link>
        <router-link class="d-block" :to="'our-priority'">
            <div class="caption round-medium shadow-huge bottom-10 card bg-text-4 bg-wrapper" :style="index==3 ? '':'opacity: 0.5'">
                <div class="position-bottom custom-mrg-btm-18 custom-horizontal-12">
                    <div class="left-text color-white bg-text-font">Our</div>
                    <div class="left-text color-white bg-text-font">Priority</div>
                </div>  
            </div>
        </router-link>
    </carousel>
</template>
<style scoped>
    .ovr-caption-mb-20 {
        margin-bottom: 20px !important;
    }
    .custom-horizontal-12 {
        margin-left: 12px !important;
        margin-right: 12px !important;
    }
    .custom-mrg-btm-18 {
        margin-bottom: 18px !important;
    }
    .custom-border {
        border-radius: 10px !important;
        overflow: hidden;
    }
    .position-bottom{
        position: absolute;
        bottom: 0;
    }
</style>
<script>
import carousel from 'vue-owl-carousel'
export default {
    name: "NavLink",
    props: {
        index: String
    },
    components: {
        carousel
    },
    computed: {
        activeBg(){
            //console.log(this.index)
           // return [parseInt(this.index),500,true]
            /*switch(this.$route.path){
                case "/get-to-know-us":
                    return { opacity: 1}
                    break;
                case "/our-business":
                    return { opacity: 1}
                    break;
                case "/our-ambition":
                    return { opacity: 1}
                    break;
                case "/axa-in-malaysia":
                    return { opacity: 1}
                    break;
                case "/follow-us":
                    return { opacity: 1}
                    break;
                default:
                    return "";
            }*/
            return '';
        }
    },
    mounted(){
        switch(this.$route.path){
            case "/about-generali":
                break;
            case "/our-history":
                break;
            case "/our-culture":
                break;
            case "/axa-priority":
                break;
        }
    }
}
</script>